import SecurityIcon from './component'

export default SecurityIcon
